"use strict";

exports.__esModule = true;
exports.AdvancedMetricChartThumbnail = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var generateBars = function generateBars(_ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height;
  var good = "#68bc00";
  var bad = "#f44e3b";
  var currentX = x + 2;
  var barWidth = 50;
  var maxBarHeight = height - 4;
  var totalPoints = Math.ceil((width - 4) / (barWidth + 2));
  var bars = [];
  for (var i = 0; i < totalPoints; i++) {
    var barHeight = maxBarHeight * Math.random();
    var currentY = y + height - barHeight;
    bars.push(/*#__PURE__*/_react["default"].createElement("rect", {
      key: String(i) + "-good",
      x: currentX,
      y: currentY,
      width: barWidth,
      height: barHeight,
      fill: good
    }));
    bars.push(/*#__PURE__*/_react["default"].createElement("rect", {
      key: String(i) + "-bad",
      x: currentX,
      y: 0,
      width: barWidth,
      height: currentY,
      fill: bad
    }));
    currentX += barWidth + 2;
  }
  return bars;
};
var AdvancedMetricChartThumbnail = exports.AdvancedMetricChartThumbnail = function AdvancedMetricChartThumbnail(_ref2) {
  var _ref2$x = _ref2.x,
    x = _ref2$x === void 0 ? 0 : _ref2$x,
    _ref2$y = _ref2.y,
    y = _ref2$y === void 0 ? 0 : _ref2$y,
    width = _ref2.width,
    height = _ref2.height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    x: x,
    y: y
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    fill: "#ffffff"
  }), generateBars({
    x: x,
    y: y,
    width: width,
    height: height
  }));
};